import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import { createFormaEntrega } from '../../services/formaEntregaService';

const initialState = {
  nome: '',
  status: '',
};

const FormaEntregaCreate = () => {
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    if (!form.nome.trim()) return 'O nome é obrigatório.';
    if (!form.status) return 'O status é obrigatório.';
    return '';
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
    setShowConfirm(true);
  };

  return (
    <div className="w-full bg-white rounded shadow p-6 mt-6">
      <h2 className="text-xl font-bold mb-4">Cadastrar Forma de Entrega</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Nome *</label>
          <input
            type="text"
            name="nome"
            value={form.nome}
            onChange={handleChange}
            maxLength={50}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
            placeholder="Nome da forma de entrega"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Status *</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            <option value="">Selecione o status</option>
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
          </select>
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {loading && <div className="text-blue-600 text-sm">Salvando...</div>}
        {success && <div className="text-green-600 text-sm">Forma de entrega cadastrada com sucesso!</div>}
        <div className="flex flex-row gap-1 justify-end mt-2 w-full overflow-x-auto">
          <button type="button" className="p-2 sm:px-4 sm:py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 flex items-center gap-2 w-10 sm:w-auto justify-center" onClick={() => navigate('/forma-entrega')}>
            <FontAwesomeIcon icon={faTimes} />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
          <button type="submit" className="p-2 sm:px-4 sm:py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 flex items-center gap-2 w-10 sm:w-auto justify-center" aria-label="Salvar">
            <FontAwesomeIcon icon={faSave} />
            <span className="hidden sm:inline">Salvar</span>
          </button>
        </div>
      </form>
      <ConfirmModal
        isOpen={showConfirm}
        title="Confirmar Cadastro"
        message="Deseja realmente cadastrar esta forma de entrega?"
        onCancel={() => setShowConfirm(false)}
        onConfirm={async () => {
          setShowConfirm(false);
          setLoading(true);
          setError('');
          setSuccess(false);
          try {
            await createFormaEntrega(form);
            setSuccess(true);
            setTimeout(() => navigate('/forma-entrega'), 1200);
          } catch (err) {
            setError('Erro ao cadastrar forma de entrega.');
          }
          setLoading(false);
        }}
      />
    </div>
  );
};

export default FormaEntregaCreate;
